// import React from 'react'
// function Foot(){
//     return (<div className="footer">
//     	</div>)
// }
// export default Foot;


import React from 'react';
import { Link } from 'react-router-dom';
import WithConsumer from '../context/WithConsumer';


const Foot = ({index,context}) => {
//
	// console.log('context HERE:', context);

	// const posts = () => context.posts;
    // const item = posts()[index];
    // const pos = posts();

    // console.log('pos:', pos);
    // console.log('item:', item);
	// const bIsSitemap = context.slug == 'sitemap' ? true : false;
	// const bIsSitemap = context.slug == 'sitemap' ? true : false;

	// function slugLinkClicked(){
 //        // context.slugLinkClicked();
 //    }


	return (<div className="footer">
		<span>&copy; jamesfawcett.co.uk</span>
		{/* &nbsp;|&nbsp;
		<Link className="footer-link" to="/">home</Link> */}
		&nbsp;|&nbsp;
		<Link className="footer-link" to="/page/privacy-policy/">privacy policy</Link>
		&nbsp;|&nbsp;
		<Link className="footer-link" to="/sitemap/">sitemap</Link>
		{/*}
		<Link className="footer-link" to="/sitemap/">sitemap</Link>
		<Link className="footer-link" to="/retrofit-cic-idrive-non-idrive-e82e88">idrive</Link>
		<Link className="footer-link" to="/1968-honda-vtec-b18c4-turbo-mini-conversion">mini</Link>
		<Link className="footer-link" to="/megajolt-tuning-maps">tuning</Link>
		*/ }
	</div>);

}
// export default Foot;
export default WithConsumer(Foot);